export default "__VITE_ASSET__RJR6fhP4__";